import React, { CSSProperties } from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
  TextareaProps,
} from '@chakra-ui/react';
import { FieldValues, UseFormRegister } from 'react-hook-form';

interface TextAreaInputFormProps extends TextareaProps {
  name: string | undefined | any;
  label: string | undefined;
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  labelStyles?: CSSProperties;
  infoButton?: JSX.Element;
  isRequired?: boolean;
  register: UseFormRegister<FieldValues>;
  errors: any;
}

export const TextAreaInputForm = ({
  name,
  label,
  labelStyles,
  isRequired = false,
  register,
  errors,
  ...rest
}: TextAreaInputFormProps) => {
  return (
    <FormControl isRequired={isRequired} isInvalid={!!errors[name]}>
      <FormLabel style={labelStyles} htmlFor={name}>
        {label}
      </FormLabel>
      <Textarea id={name} minH="160px" {...register(name)} {...rest} />
      {errors[name] && (
        <FormErrorMessage fontSize="12px" color="state.destructive">
          {errors[name]?.message}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};
